import InitBookFavorites from './Book'

InitBookFavorites()
